import type { CityConfig } from "../city-template/types";

export const hobbsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hobbs",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "hobbs",
  route: "/hobbs",
  title: "Emergency Passport Hobbs, NM — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Hobbs, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Lea County oilfield workers, USW students, cross-border business travelers, and southeastern New Mexico families.",
  h1: "Emergency & Expedited Passport Services in Hobbs, NM",
  heroSubtitle: "Oilfield assignment overseas starting next week? USW semester abroad orientation in Juarez? Family reunion south of the border and the kids need passports? We help Hobbs residents — from Lea County energy workers to university students to Lovington and Eunice families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Hobbs%20New%20Mexico%20at%20golden%20sunset%20with%20the%20Permian%20Basin%20landscape%20stretching%20across%20the%20horizon%2C%20oil%20pump%20jacks%20silhouetted%20against%20a%20dramatic%20southwestern%20sky%2C%20wide%20open%20high%20plains%20desert%20with%20sparse%20sagebrush%2C%20the%20Zia%20Park%20Casino%20and%20modern%20energy%20industry%20buildings%20visible%20in%20the%20distance%2C%20professional%20travel%20photography%20with%20warm%20amber%20and%20terracotta%20tones&width=1800&height=700&seq=hobbs-hero-2026&orientation=landscape",
  heroImageAlt: "Hobbs New Mexico Permian Basin landscape at golden sunset",
  geoPosition: "32.7026;-103.1360",
  geoPlacename: "Hobbs, New Mexico",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "El Paso Passport Agency",
    address: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
    distance: "Located in downtown El Paso, TX — approximately 270 miles southwest of Hobbs. Appointments required, typically booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "Hobbs", zips: "88240, 88241, 88242" },
    { name: "Lovington", zips: "88260" },
    { name: "Eunice", zips: "88231" },
    { name: "Jal", zips: "88252" },
    { name: "Tatum", zips: "88267" },
    { name: "Carlsbad", zips: "88220, 88221" },
    { name: "Artesia", zips: "88210, 88211" },
    { name: "Seminole (TX)", zips: "79360" },
    { name: "Denver City (TX)", zips: "79323" },
    { name: "Lubbock (closest major airport)", zips: "79401–79499" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Lea County Emergency Processing", desc: "Reserved courier access to the El Paso Passport Agency — as fast as 24 hours for Hobbs-area travelers with immediate departures." },
    { icon: "ri-oil-line", title: "Oilfield & Energy Sector Travel Ready", desc: "Lea County is the heart of the Permian Basin. We handle expedited passports for oilfield workers, engineers, and executives with short-notice international assignments and training rotations." },
    { icon: "ri-flight-takeoff-line", title: "Regional Airport Connections", desc: "Lea County Regional Airport (HOB) connects to Houston and Denver for international gateways. Lubbock Preston Smith (LBB) is 110 miles away with more options. We coordinate timing around your regional departures." },
    { icon: "ri-graduation-cap-line", title: "USW Student & Cross-Border Support", desc: "University of the Southwest students studying abroad, plus frequent cross-border travel to Mexico for family, business, and medical services — we understand southeastern NM travel patterns." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albuquerque, NM", route: "/albuquerque" },
    { name: "Expedited passport in Carlsbad, NM", route: "/carlsbad-nm" },
    { name: "Urgent passport services in El Paso, TX", route: "/el-paso" },
    { name: "New Mexico passport services overview", route: "/new-mexico" },
  ],
  fpcOfficeAddress: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
  fpcOfficeNote: "Fast Passport Center serves Hobbs via secure registered courier with direct access to the El Paso Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Hobbs residents can ship from any UPS Store, FedEx Office, or post office location across Lea County.",
  fpcOfficeDistance: "Serving Hobbs, Lovington, Eunice, Jal, Tatum, and all Lea County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Hobbs and all of Lea County. From the downtown business district along Turner Street to the north-side residential neighborhoods, from the Hobbs Municipal Schools area to the USW campus — we serve the entire southeastern New Mexico oil patch. Our courier service eliminates the need to drive 270 miles to El Paso and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Hobbs and all Lea County communities including Lovington, Eunice, Jal, and Tatum. We also serve neighboring Eddy County (Carlsbad, Artesia) and nearby West Texas communities including Seminole and Denver City. Lubbock Preston Smith International Airport (LBB) is the closest major airport at 110 miles away.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Hobbs as simple as possible — with the efficiency and reliability Lea County energy workers, USW students, and southeastern NM families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Hobbs travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Hobbs travelers encounter unique passport issues — everything from oilfield rotation timing to cross-border documentation for dual-national families. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Hobbs travelers — from Permian Basin energy workers to USW students to Lea County families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Hobbs, NM? Here are the most common ones we hear from Lea County travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before an overseas oilfield rotation, an emergency passport for a last-minute Mexico trip, or a first-time passport for a USW study-abroad program — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.leacounty.net/government/departments/treasurer",
  dmvLabel: "Lea County MVD — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Oilfield assignment overseas in 3 days? Family emergency in Mexico requiring immediate travel? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Hobbs-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Hobbs residents renew fast — no agency visit required for most renewals. Perfect for Lea County energy professionals and southeastern NM families preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Hobbs residents through every step — from downtown to Lovington Highway — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your oilfield rotation or cross-border trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Lea County family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for southeastern NM residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent travel? Ideal for Lea County energy executives and contractors who travel internationally while their primary passport is in visa processing for multiple countries.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Permian Basin travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Perfect for Lea County residents who frequently cross into Mexico by land.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Hobbs NM", description: "Urgent passport processing for Hobbs New Mexico travelers with immediate departure needs from Lea County Regional Airport." },
    { name: "Expedited Passport Renewal Hobbs NM", description: "Fast passport renewal for Hobbs New Mexico residents with a previously-issued passport." },
    { name: "First-Time Passport Hobbs NM", description: "New passport application services for Hobbs New Mexico residents applying for their first passport." },
    { name: "Child Passport Hobbs NM", description: "Minor passport services for Hobbs New Mexico families with children under 16." },
    { name: "Name Change Passport Hobbs NM", description: "Passport name correction after marriage, divorce, or legal name changes for Hobbs residents." },
    { name: "Second Passport Hobbs NM", description: "Second passport services for Lea County energy executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "James R.",
      location: "Hobbs",
      rating: 5,
      text: "I got called up for a two-week oilfield assignment in Saudi Arabia with 5 days notice. My passport had expired and I was panicking. Fast Passport Center got it back in 48 hours. The document review was thorough — they caught a photo issue before submission.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Garcia Family",
      location: "Lovington",
      rating: 5,
      text: "We planned a family trip to visit relatives in Chihuahua and realized the kids' passports were expired. They walked us through the child passport process step by step. All four passports arrived in 6 days. Amazing service for Lea County families.",
      service: "Child Passport Renewal",
    },
    {
      name: "Cynthia M.",
      location: "Hobbs (USW)",
      rating: 5,
      text: "I'm a USW nursing student and my summer program in Costa Rica started in 10 days. My passport application had an error I never would have caught. They reviewed everything and got my new passport back in time. Lifesavers.",
      service: "New Passport",
    },
    {
      name: "Robert T.",
      location: "Eunice",
      rating: 5,
      text: "Needed a name change after marriage and a renewal for a business conference in Calgary. Even living out in Eunice, the whole process was smooth — shipped documents from the local post office and had my new passport in 7 days.",
      service: "Name Change Passport",
    },
  ],
  facilities: [
    {
      id: "hob-1",
      name: "Hobbs Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Clinton St",
      city: "Hobbs",
      state: "NM",
      zip: "88240",
      phone: "(575) 397-3659",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Hobbs",
      website: "https://tools.usps.com/find-location.htm?location=1376539",
      websiteLabel: "USPS Location",
      notes: "Main passport acceptance facility in Hobbs. Photo services on-site. Serves downtown Hobbs and the Turner Street corridor. Appointment strongly recommended — walk-in availability is limited.",
      icon: "ri-mail-line",
    },
    {
      id: "hob-2",
      name: "Lovington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 S Main Ave",
      city: "Lovington",
      state: "NM",
      zip: "88260",
      phone: "(575) 396-2811",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Lovington — Lea County seat",
      website: "https://tools.usps.com/find-location.htm?location=1376541",
      websiteLabel: "USPS Location",
      notes: "Serves Lovington and northern Lea County. Smaller facility — call ahead for passport hours. Photo services available. Convenient alternative to Hobbs for north county residents.",
      icon: "ri-mail-line",
    },
    {
      id: "hob-3",
      name: "Lea County Clerk — Lovington",
      type: "County Clerk Passport Acceptance",
      address: "100 N Main Ave, Suite 100",
      city: "Lovington",
      state: "NM",
      zip: "88260",
      phone: "(575) 396-8619",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Lovington — Lea County Courthouse",
      website: "https://www.leacounty.net/government/departments/county-clerk",
      websiteLabel: "Lea County Clerk",
      notes: "Official county clerk passport acceptance facility. Serves all of Lea County. No photo services on-site — bring completed passport photos. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "hob-4",
      name: "Eunice Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1205 Avenue J",
      city: "Eunice",
      state: "NM",
      zip: "88231",
      phone: "(575) 394-2569",
      hours: "Mon–Fri 9:00 AM – 3:00 PM",
      distance: "Eunice — southern Lea County",
      website: "https://tools.usps.com/find-location.htm?location=1367465",
      websiteLabel: "USPS Location",
      notes: "Serves Eunice, Jal, and southern Lea County near the Texas border. Smaller facility with limited hours — call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "hob-5",
      name: "Carlsbad Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 S Canal St",
      city: "Carlsbad",
      state: "NM",
      zip: "88220",
      phone: "(575) 885-3161",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Carlsbad — Eddy County",
      website: "https://tools.usps.com/find-location.htm?location=1376533",
      websiteLabel: "USPS Location",
      notes: "Largest facility within reasonable driving distance, about 70 miles from Hobbs. Full photo services available. Serves Eddy County and nearby Lea County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "hob-6",
      name: "Lubbock Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3601 Postal Dr",
      city: "Lubbock",
      state: "TX",
      zip: "79401",
      phone: "(806) 472-1515",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Lubbock — 110 miles northeast",
      website: "https://tools.usps.com/find-location.htm?location=1376540",
      websiteLabel: "USPS Location",
      notes: "Convenient for Hobbs residents already traveling to Lubbock for airport departures or shopping. Full photo services available. Large facility with more appointment availability than rural NM locations.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to El Paso Passport Agency (270 miles)", fpc: "Most Hobbs travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Rural NM Guidance", agency: "Generic — no Lea County, oilfield, or cross-border expertise", fpc: "Full Lea County/energy sector/cross-border knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming El Paso Agency Is Close Enough to Walk In",
      description: "The El Paso Passport Agency is 270 miles from Hobbs — a 4+ hour drive each way. Many Lea County residents make the trip only to be turned away without an appointment. Our courier channel eliminates this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Last-Minute Oilfield Rotation Passport Rush",
      description: "Lea County energy workers often get international assignment notices with very short timelines. A single DS-82 form error can delay processing by 1-2 weeks. We review every document before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cross-Border Mexico Travel Without Passport Card",
      description: "Many Lea County residents have family in Chihuahua and Coahuila but assume a driver's license or birth certificate works for border crossings. It does not. We help you get the correct passport documentation.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Southeastern NM families frequently overlook the DS-3053 consent form when one parent is working out of town on an oilfield rotation. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Limited Acceptance Facility Hours in Rural Areas",
      description: "Hobbs and Lovington facilities have shorter hours than big-city post offices. Travelers who show up on a Friday afternoon with no appointment often miss the window and lose an entire weekend. We help you plan your visit.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or USW dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Hobbs clients ship from the Main Post Office on Clinton Street or from home." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 4+ hours to El Paso or wait at the passport agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Hobbs?", a: "We offer Hobbs-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Hobbs?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Hobbs Post Office or Lea County Clerk in Lovington), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Hobbs address." },
    { q: "Where can I get passport acceptance in Lea County?", a: "Hobbs has acceptance at the Main Post Office on Clinton Street. Lovington has both the Post Office and the Lea County Clerk. Eunice and Carlsbad also have facilities. We maintain an updated list with hours, photo availability, and appointment options." },
    { q: "What is the closest passport agency to Hobbs?", a: "The closest passport agency is the El Paso Passport Agency at 700 E San Antonio Ave, El Paso, TX — approximately 270 miles southwest. However, it only serves travelers with life-or-death emergencies. For standard expedited needs, our courier channel is faster and more accessible than driving to El Paso." },
    { q: "Can you help energy sector workers with urgent passports?", a: "Yes. We regularly assist Permian Basin oilfield workers, engineers, and contractors with expedited passports for international assignments, training, and conferences. We understand the short-notice nature of energy sector travel and prioritize these cases." },
    { q: "What documents do Hobbs applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Hobbs-specific checklist." },
    { q: "Can I drive to Lubbock for passport acceptance?", a: "Yes. The Lubbock Main Post Office (110 miles northeast) is a large facility with more appointment availability than rural Lea County locations. Many Hobbs residents combine passport acceptance with a Lubbock shopping trip or airport departure. We can advise on which facility is best for your timeline." },
    { q: "How do I check my passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Hobbs to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help with cross-border Mexico travel documentation?", a: "Yes. Many Lea County residents have family in Mexico and cross the border regularly. We help with both passport books and passport cards, and can advise on which documentation is right for your travel patterns." },
    { q: "Can I get a passport photo in Hobbs?", a: "Yes. The Hobbs Main Post Office offers photo services on-site. CVS, Walgreens, and Walmart in Hobbs also offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
  ],
  photoLocations: [
    { name: "Walgreens — Hobbs", address: "1800 N Turner St, Hobbs, NM 88240", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Hobbs", address: "2400 N Grimes St, Hobbs, NM 88240", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Hobbs", address: "3800 N Lovington Hwy, Hobbs, NM 88240", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "Hobbs Main Post Office Photos", address: "201 E Clinton St, Hobbs, NM 88240", hours: "Mon–Fri 9 AM – 4 PM", website: "https://tools.usps.com/find-location.htm" },
  ],
  dmvLocations: [
    {
      name: "Lea County MVD — Lovington",
      address: "100 N Main Ave, Lovington, NM 88260",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Driver licenses, REAL ID, vehicle registration. County seat location. Appointment recommended.",
      featured: true,
    },
    {
      name: "New Mexico MVD — Hobbs",
      address: "1920 N Dal Paso St, Hobbs, NM 88240",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full-service MVD office in Hobbs. REAL ID available. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HOB",
      name: "Lea County Regional Airport",
      distance: "About 5 miles west of downtown Hobbs",
      address: "6600 W Carlsbad Hwy, Hobbs, NM 88240",
      note: "Regional airport with United Express service to Houston (IAH) and Denver (DEN) — major international connecting hubs. Convenient for Lea County departures.",
      flightUrl: "https://www.leacounty.net/government/departments/airport",
      flightLabel: "Lea County Airport Website",
      featured: true,
    },
    {
      code: "LBB",
      name: "Lubbock Preston Smith International Airport",
      distance: "About 110 miles northeast of Hobbs",
      address: "5401 N Martin L King Blvd, Lubbock, TX 79403",
      note: "Closest major airport with more carrier options. American, Southwest, and United service to DFW, DEN, IAH, PHX, and LAS for international connections.",
      flightUrl: "https://www.flylbb.com/",
      flightLabel: "LBB Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New Mexico Department of Health. Online, mail, or in-person options available for Lea County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NM Department of Health Vital Records. Required for estate and legal matters in Lea County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Lea County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.leacounty.net/government/departments/county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Fifth Judicial District Court. Required for name change passport corrections.",
      url: "https://fifthdistrictcourt.nmcourts.gov/",
    },
  ],
};